import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/sdk-missing-params-message')({
  beforeLoad: () => {
    throw redirect({
      to: '/n/sdk-missing-params-message',
      replace: true,
    });
  },
});
